const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    spacer: {
        padding: "10px",
    },
    networkBlock: {
        // backgroundColor: "#e0e0e0",
        marginTop: "15px",
        marginBottom: "15px",
        width: "350px",
    },
    layerName: {
        fontSize: "0.9rem",
        fontWeight: 700,
    },
    layerDetails: {
        fontSize: "0.75rem",
        fontWeight: 400,
    }
});

export default styles;